export const TrackingStatus = {
  UnTrackable: 'UnTrackable',
  NotShipped: 'NotShipped',
  Delivered: 'Delivered',
  DeliveryError: 'DeliveryError',
  Shipped: 'Shipped',
};
